import crud from './_crud'
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'
import Swal from 'sweetalert2'
import { getRol, createHeaders } from '../../utils/rol'
import i18next from 'i18next'
const t = (key) => i18next.t(key)

const entity = 'unit'
const entityMsg = 'unit'

const actions = crud('unit', 'la unidad', 'las unidades')

const getFuelCatalog = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/utils/get_fuel_type_catalog`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		dispatch({
			type: `GET_${entity.toUpperCase()}_TYPES`,
			response: res.body,
		})

		return res.body
	}
}

const getCurrentOdometerUnits = () => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/unit/utils/get_current_odometer_units`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		if (res.body.success) {
			dispatch({
				type: `GET_ODOMETERS_UNITS_PAGE`,
				payload: res.body.list,
			})

			return res.body
		}

		showErrorMessage(t('Ha ocurrido un error al ejecutar getCurrentOdometerUnits'))
	}
}

const getTypesCatalog = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/utils/get_unit_type_catalog`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		dispatch({
			type: `GET_${entity.toUpperCase()}_TYPES`,
			response: res.body,
		})

		return res.body
	}
}

const updateUnitEmployee = ({ documento, ...item }, unit_id, employee_id) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(
			`/${entity}/update_unit_employee/${unit_id}/${employee_id}`,
			{
				method: 'PATCH',
				body: JSON.stringify(item),
				headers: {
					Authorization: state.app.user.token,
				},
				successMessage: t('Se sincronizó al chofer con la unidad correctamente.'),
			}
		)

		dispatch({
			type: `UPDATE_${entity.toUpperCase()}_EMPLOYEE`,
			response: res.body,
			payload: unit_id,
		})

		return res.body
	}
}

const addUnitEmployee = ({ documento, ...item }, unit_id, employee_id) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(
			`/${entity}/add_unit_employee/${unit_id}/${employee_id}`,
			{
				method: 'POST',
				body: JSON.stringify(item),
				headers: {
					Authorization: state.app.user.token,
				},
				successMessage: t('Se sincronizó al chofer con la unidad correctamente.'),
			}
		)

		dispatch({
			type: `ADD_${entity.toUpperCase()}_EMPLOYEE`,
			response: res.body,
			payload: unit_id,
		})

		return res.body
	}
}

const assignTires = ({
	unit_params,
	unit_id,
	tires,
	files = [],
	additional_values,
}) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/${entity}/utils/${unit_id}/assign_tires`, {
			method: 'PATCH',
			json: false,
			body: {
				tires: JSON.stringify(tires),
				unit_params: JSON.stringify(unit_params),
				identified_files: JSON.stringify(files),
				files: files.map((f) => f.File),
				additional_values: JSON.stringify(additional_values),
			},
			headers: {
				Authorization: state.app.user.token,
			},
			// successMessage: `Se guardo correctamente la asignación de llantas.`,
		})

		Swal.fire({
			title: t('¡Acción Realizada!'),
			text: t('Operación realizada correctamente.'),
			icon: 'success',
			confirmButtonText: t('Ok'),
			showCloseButton: true,
		}).then((result) => {
			if (result.isConfirmed) {
				window.location.reload()
			}
		})

		return res.body
	}
}

const createTire = ({ unit_id, body }) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/${entity}/${unit_id}/create_tire`, {
			method: 'POST',
			body: JSON.stringify(body),
			headers: {
				Authorization: state.app.user.token,
			},
			successMessage: t('Se guardo correctamente la asignación de llantas.'),
		})

		// dispatch(actions.get(unit_id))

		return res.body
	}
}

const updateTire = ({ unit_id, body }) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/${entity}/${unit_id}/update_tire`, {
			method: 'PATCH',
			body: JSON.stringify(body),
			headers: {
				Authorization: state.app.user.token,
			},
			successMessage: t('Se guardo correctamente la asignación de llantas.'),
		})

		// dispatch(actions.get(unit_id))

		return res.body
	}
}

const setUnitTireOperation = (unitParams, options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/${entity}/set_tire_operation`, {
			method: 'POST',
			body: JSON.stringify({
				options: options,
				unit_params: unitParams,
			}),
			headers: {
				Authorization: state.app.user.token,
			},
			successMessage: t('Se guardo correctamente la asignación de llantas.'),
		})

		// dispatch(actions.get(unit_id))

		return res.body
	}
}

const loadWialonUnits = () => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/wialon/units`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		dispatch({
			type: `GET_${entity.toUpperCase()}S_WIALON`,
			response: res.body,
		})

		return res.body
	}
}

const loadXigaVehicles = () => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/xiga/vehicles`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		dispatch({
			type: `GET_${entity.toUpperCase()}S_XIGA`,
			response: res.body,
		})

		return res.body
	}
}

const getWialonUnits = () => {
	return async (dispatch, getState) => {
		const state = getState()
		const rol = getRol(state)
		const headers = createHeaders(state, rol);
		try {
			const res = await callApi(`/wialon/client_units`, {
				method: 'GET',
				headers,
			})
			dispatch({ type: `GET_${entity.toUpperCase()}S_WIALON`, response: res.body })
			return res.body
		} catch (err) {
			console.error('Error al cargar unidades Wialon:', err)
			return []   // para que la promesa se resuelva siempre
		}
	}
}

const generateLocator = (unit_id, wialon_id) => {
	console.log('generateLocator - unit_id:', unit_id, 'wialon_id:', wialon_id)
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/unit/${unit_id}/generate_locator`, {
				method: 'POST',
				headers: {
					Authorization: state.app.user.token,
				},
				body: JSON.stringify({ wialon_id }),
				successMessage: t('Locator generado exitosamente'),
			})

			return res.body
		} catch (error) {
			showErrorMessage(error.message || t('Error al generar el locator'))
			return null
		}
	}
}

const getWialonUnitEntity = (id) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/wialon/unit_wialon/${id}`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		dispatch({
			type: `GET_${entity.toUpperCase()}S_WIALON`,
			response: res.body,
		})

		return res.body
	}
}

const getWialonUnitEntityByUserType = ({ userType }, id) => {
	return async (dispatch, getState) => {
		const state = getState()
		const params = {}
		const sys_company_id = state.app[userType].sys_company_id
		params.sys_company_id = sys_company_id
		const res = await callApi(`/wialon/unit_wialon_by_usertype/${id}`, {
			method: 'GET',
			headers: {
				Authorization: state.app[userType].token,
			},
			params: params,
		})

		dispatch({
			type: `GET_${entity.toUpperCase()}S_WIALON`,
			response: res.body,
		})

		return res.body
	}
}

const loadWialonUnitByID = (id) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/unit/${id}`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		dispatch({
			type: `GET_${entity.toUpperCase()}_WIALON`,
			response: res.body,
		})

		return res.body
	}
}

const batchUnitWialonReport = ({ unitData, interval }) => {
	return async (dispatch, getState) => {
		const state = getState()
		const res = await callApi(`/wialon/batch_unit_report`, {
			method: 'POST',
			body: JSON.stringify({ unitData, interval }),
			headers: {
				Authorization: state.app.user.token,
			},
		})
		return res.body
	}
}

const getUnitsVisitedGeofences = (options, interval, routesStops, unitParkingZone) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/wialon/getUnitsVisitedGeofences`, {
			method: 'POST',
			body: JSON.stringify({
				units: options,
				interval: interval,
				routesStops: routesStops,
				unitParkingZone
			}),
			headers: {
				Authorization: state.app.user.token,
			},
		})

		return res.body
	}
}

const getGeofenceZones = () => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/wialon/get_geofence_zones`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		return res.body
	}
}

const addImage = (unit_id, files) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/unit/${unit_id.id}/upload_image`, {
			method: 'PUT',
			json: false,
			headers: {
				Authorization: state.app.user.token,
			},
			body: {
				file: files,
				item: JSON.stringify(unit_id),
			},
			successMessage: t('Se subió la imagen correctamente'),
		})

		// dispatch(actions.get(unit_id))
	}
}

const deleteImage = (unit_id) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/unit/${unit_id.id}/image`, {
			method: 'DELETE',
			json: false,
			headers: {
				Authorization: state.app.user.token,
			},
			successMessage: t('Se eliminó la imagen correctamente'),
		})

		// dispatch(actions.get(unit_id))
	}
}

const deleteUnit = (item) => {
	return async (dispatch, getState) => {
		const state = getState()
		const res = await callApi(`/unit/${item.id}/delete_unit`, {
			method: 'DELETE',
			headers: {
				Authorization: state.app.user.token,
			},
			successMessage: t('Se eliminó la unidad correctamente.'),
		})
	}
}

const createUnitWithImage = (item, files) => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/unit/create_unit_with_image`, {
				method: 'PUT',
				json: false,
				headers: {
					Authorization: state.app.user.token,
				},
				body: {
					file: files,
					item: JSON.stringify(item),
				},

				successMessage: t('Se agrego la unidad correctamente'),
			})

			dispatch({
				type: 'ADD_UNIT',
				response: res.body,
			})

			return res.body
		} catch (error) {
			return null
		}
	}
}

const updateUnitWithImage = (item, files) => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/unit/update_unit_with_image`, {
				method: 'PUT',
				json: false,
				headers: {
					Authorization: state.app.user.token,
				},
				body: {
					file: files,
					item: JSON.stringify(item),
					documentItemData: JSON.stringify(item.DocumentItems),
				},
				successMessage: t('Se actualizó la unidad correctamente'),
			})

			dispatch({
				type: 'UPDATE_UNIT',
				response: res.body,
			})

			return res.body
		} catch (error) {
			return null
		}
	}
}

const loadClientUnits = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/unit/utils/client_units`, {
			method: 'GET',
			headers: {
				Authorization: state.app.client.token,
			},
		})

		dispatch({
			type: `LOAD_UNITS`,
			response: res.body,
		})

		return res.body
	}
}

const loadUnitsUserCompany = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/unit/load_units_user_company`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
			params: options.params,
		})

		dispatch({
			type: `LOAD_UNITS`,
			response: res.body,
		})

		return res.body
	}
}

const getUnitWialonValuesBydate = (query) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/unit/utils/get_unit_wialon_values_by_date_v2`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
			params: query,
		})

		return res.body
	}
}

const getUnitPhysiqueValuesBydate = (query) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/unit/utils/get_unit_physique_values_by_date`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
			params: query,
		})

		return res.body
	}
}

const getUnitOdometerHistory = (query) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(
			`/unit_odometer_history/utils/get_unit_odometer_history`,
			{
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
				params: query,
			}
		)
		dispatch({
			type: `GET_UNIT_ODOMETER_HISTORY`,
			response: res.body,
		})
		return res.body
	}
}

const getUnitOdometerHistoryByUserType = ({ userType }, query) => {
	return async (dispatch, getState) => {
		const state = getState()
		const sys_company_id = state.app[userType].sys_company_id
		query.sys_company_id = sys_company_id
		const res = await callApi(
			`/unit_odometer_history/utils/get_unit_odometer_history_form_by_usertype`,
			{
				method: 'GET',
				headers: {
					Authorization: state.app[userType].token,
				},
				params: query,
			}
		)
		dispatch({
			type: `GET_UNIT_ODOMETER_HISTORY`,
			response: res.body,
		})
		return res.body
	}
}

const getUnitHourmeterHistory = (query) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(
			`/unit_hourmeter_history/utils/get_unit_hourmeter_history`,
			{
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
				params: query,
			}
		)

		dispatch({
			type: `GET_UNIT_HOURMETER_HISTORY`,
			response: res.body,
		})
		return res.body
	}
}

const getUnitHourmeterHistoryByUsertype = ({ userType }, query) => {
	return async (dispatch, getState) => {
		const state = getState()
		const sys_company_id = state.app[userType].sys_company_id
		query.sys_company_id = sys_company_id
		const res = await callApi(
			`/unit_hourmeter_history/utils/get_unit_hourmeter_history_by_usertype`,
			{
				method: 'GET',
				headers: {
					Authorization: state.app[userType].token,
				},
				params: query,
			}
		)

		dispatch({
			type: `GET_UNIT_HOURMETER_HISTORY`,
			response: res.body,
		})
		return res.body
	}
}

const driverGetUnitOdometerHistory = (query) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(
			`/unit_odometer_history/utils/driver_get_unit_odometer_history`,
			{
				method: 'GET',
				headers: {
					Authorization: state.app.driver?.token || '',
				},
				params: query,
			}
		)
		dispatch({
			type: `GET_UNIT_ODOMETER_HISTORY`,
			response: res.body,
		})
		return res.body
	}
}

const driverGetUnitHourmeterHistory = (query) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(
			`/unit_hourmeter_history/utils/driver_get_unit_hourmeter_history`,
			{
				method: 'GET',
				headers: {
					Authorization: state.app.driver?.token || '',
				},
				params: query,
			}
		)
		dispatch({
			type: `GET_UNIT_HOURMETER_HISTORY`,
			response: res.body,
		})
		return res.body
	}
}

const importUnits = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/unit/import_units`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				options,
			}),
			successMessage: t('Se agreron las unidades correctamente.'),
		})
		showSuccessMessage(t('Se registraron las unidades correctamente'))
		return res.body
	}
}

const importUnitsWialon = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/unit/import_units_wialon`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				options,
			}),
			// successMessage: `Se agreron las unidades de wialon correctamente.`,
		})
		// showSuccessMessage('Se registraron las unidades de wialon correctamente')
		Swal.fire({
			title: t('¡Acción Realizada!'),
			text: t('Se agreron las unidades de wialon correctamente.'),
			icon: 'success',
			confirmButtonText: t('Ok'),
			showCloseButton: true,
		}).then((result) => {
			if (result.isConfirmed) {
				window.location.reload()
			}
		})
		return res.body
	}
}

const loadUnits = ({ userType }) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/unit/form_instance_all_units`, {
			method: 'GET',
			headers: {
				Authorization: state.app[userType].token,
			},
			params: {
				userType: userType,
				sys_company_id: state.app[userType].sys_company_id,
			},
		})

		dispatch({
			type: `GET_ALL_UNITS`,
			payload: res.body.response,
		})
		return res.body
	}
}

const upsertUserUnitPermits = (item) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/unit/upsert_user_unit_permits`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify(item),
			successMessage: t('Los permisos se guardaron correctamente.'),
		})
		showSuccessMessage(t('Los permisos se guardaron correctamente.'))
		return res.body
	}
}

const getUserUnitPermits = (userId) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/unit/utils/get_user_unit_permits`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
			params: { userId: userId },
		})

		return res.body
	}
}

const getUnitIgniteSensor = (unit_id) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/unit/utils/get_unit_ignite_sensor`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
			params: { unit_id: unit_id },
		})

		return res.body
	}
}

const loadAllUnits = () => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/unit/all_units`, {
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			})

			return res.body
		} catch (error) {
			return []
		}
	}
}

const loadNotImportedWialonUnits = () => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/wialon/not_imported_units`, {
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			})

			return res.body
		} catch (error) {
			return []
		}
	}
}

const getUnitWithSensors = (unit_id) => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/unit/utils/get_unit_sensors_list`, {
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
				params: unit_id,
			})

			return res.body
		} catch (error) {
			console.log(error)
			return []
		}
	}
}

const getUnitsForPerformanceReporting = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/unit/get_units_for_performance_reporting`, {
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			})

			return res.body
		} catch (error) {
			console.log(error)
			return []
		}
	}
}

const getUnitsForFuelDispatch = () => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/unit/get_units_for_fuel_dispatch`, {
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
					usertype: 'user_id',
				},
			})

			return res.body
		} catch (error) {
			console.log(error)
			return []
		}
	}
}

const getCustomUnits = (params) => {
	return async (dispatch, getState) => {
		const state = getState()

		dispatch({
			type: 'SET_LOADING_UNITS',
			payload: true,
		})

		const res = await callApi(`/unit/custom_units`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
			params,
		})

		dispatch({
			type: 'SET_CUSTOM_UNITS',
			payload: res.body,
		})

		dispatch({
			type: 'SET_LOADING_UNITS',
			payload: false,
		})

		return res.body
	}
}

const getUnits = () => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/unit/utils/get_units`, {
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			})

			return res.body
		} catch (error) {
			return []
		}
	}
}

// brands
const getUniqueUnitBrands = () => {
	return async (dispatch, getState) => {
		const state = getState()

		const rol = getRol(state)
		const headers = createHeaders(state, rol);

		const res = await callApi('/unit/get_unique_unit_brands', {
			method: 'GET',
			headers,
		})

		return res.body
	}
}

const countUnitsByBrand = (brand, unit_id) => {
	return async (dispatch, getState) => {
		const state = getState()

		const rol = getRol(state)
		const headers = createHeaders(state, rol);

		const searchParams = new URLSearchParams()
		searchParams.append('brand', brand)
		searchParams.append('unit_id', unit_id)

		const res = await callApi(`/unit/count_units_by_brand?${searchParams.toString()}`, {
			method: 'GET',
			headers,
		})

		return res.body
	}
}

const updateUnitsBrand = (unitsIDs, brand) => {
	return async (dispatch, getState) => {
		const state = getState()

		const rol = getRol(state)
		const headers = createHeaders(state, rol);

		const res = await callApi(`/unit/update_units_brand`, {
			method: 'PATCH',
			headers,
			body: JSON.stringify({
				unitsIDs,
				brand,
			}),
		})

		return res.body;
	}
}

// models
const getUniqueUnitModels = () => {
	return async (dispatch, getState) => {
		const state = getState()

		const rol = getRol(state)
		const headers = createHeaders(state, rol);

		const res = await callApi('/unit/get_unique_unit_models', {
			method: 'GET',
			headers,
		})

		return res.body
	}
}

const countUnitsByModel = (model, unit_id) => {
	return async (dispatch, getState) => {
		const state = getState()

		const rol = getRol(state)
		const headers = createHeaders(state, rol);

		const searchParams = new URLSearchParams()
		searchParams.append('model', model)
		searchParams.append('unit_id', unit_id)

		const res = await callApi(`/unit/count_units_by_model?${searchParams.toString()}`, {
			method: 'GET',
			headers,
		})

		return res.body
	}
}

const updateUnitsModel = (unitsIDs, model) => {
	return async (dispatch, getState) => {
		const state = getState()

		const rol = getRol(state)
		const headers = createHeaders(state, rol);

		const res = await callApi(`/unit/update_units_model`, {
			method: 'PATCH',
			headers,
			body: JSON.stringify({
				unitsIDs,
				model,
			}),
		})

		return res.body;
	}
}

const copySupplyConfiguration = ({ source_unit_id, target_unit_ids, fields }) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/unit/copy_supply_configuration`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				source_unit_id,
				target_unit_ids,
				fields,
			}),
			successMessage: t('Configuración de suministro copiada correctamente.'),
		})

		return res.body
	}
}

const regenerateLocator = (unit_id, wialon_id) => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/unit/${unit_id}/regenerate_locator`, {
				method: 'POST',
				headers: {
					Authorization: state.app.user.token,
				},
				body: JSON.stringify({ wialon_id }),
				successMessage: 'Locator regenerado exitosamente',
			})

			return res.body
		} catch (error) {
			showErrorMessage(error.message || 'Error al regenerar el locator')
			return null
		}
	}
}

const getUnitsWithWialon = () => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/unit/get_units_with_wialon`, {
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			})

			return res.body
		} catch (error) {
			return []
		}
	}
}

const getUnitsWithXiga = () => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/unit/get_units_with_xiga`, {
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			})

			return res.body
		} catch (error) {
			return []
		}
	}
}

const getWialonCustomReportTemplate = () => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/wialon/get_wialon_custom_report_template`, {
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			})

			return res.body
		} catch (error) {
			throw error
		}
	}
}

const createCustomReport = (unitIds, startDate, endDate, reportTemplateId) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/unit/create_custom_report`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				unitIds,
				startDate,
				endDate,
				reportTemplateId,
			})
		})

		return res.body
	}
}

const renameUnitsFromWialon = (data) => {
	return async (dispatch, getState) => {
		const state = getState()
		const token = state.app.user.token

		const results = await Promise.allSettled(
			data.map((item) =>
				callApi(`/unit/${item.id}`, {
					method: 'PATCH',
					body: JSON.stringify({ name: item.name, serial_no: item.serial_no }),
					headers: {
						Authorization: token,
					},
					showDefaultAlertError: false,
				})
			)
		)

		const failed = results.filter(
			(r) => r.status === 'rejected' || r.value?.status !== 200
		)

		if (failed.length === 0) {
			Swal.fire({
				title: t('¡Acción Realizada!'),
				text: `${t('Se renombraron')} ${data.length} ${t('unidades correctamente.')}`,
				icon: 'success',
				confirmButtonText: t('Ok'),
				showCloseButton: true,
			}).then((result) => {
				if (result.isConfirmed) {
					window.location.reload()
				}
			})
		} else if (failed.length < data.length) {
			Swal.fire({
				title: t('Acción parcial'),
				text: `${t('Se renombraron')} ${data.length - failed.length} ${t('de')} ${data.length} ${t('unidades.')} ${failed.length} ${t('fallaron.')}`,
				icon: 'warning',
				confirmButtonText: t('Ok'),
				showCloseButton: true,
			}).then((result) => {
				if (result.isConfirmed) {
					window.location.reload()
				}
			})
		} else {
			Swal.fire({
				title: t('Error'),
				text: t('No se pudo renombrar ninguna unidad.'),
				icon: 'error',
				confirmButtonText: t('Ok'),
			})
		}

		return results
	}
}

const getUnitOperatorConfigs = (unit_id) => {
	return async (dispatch, getState) => {
		const state = getState()
		const res = await callApi(`/unit_operator_config/${unit_id}`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})
		return res.body
	}
}

const createUnitOperatorConfig = (body) => {
	return async (dispatch, getState) => {
		const state = getState()
		const res = await callApi(`/unit_operator_config`, {
			method: 'POST',
			body: JSON.stringify(body),
			headers: {
				Authorization: state.app.user.token,
			},
			shouldSkipStatusError: true,
		})

		if (res.status !== 200) throw new Error(res.body.error)

		return res.body

	}
}

const updateUnitOperatorConfig = (unit_operator_config_id, body) => {
	return async (dispatch, getState) => {
		const state = getState()
		const res = await callApi(`/unit_operator_config/${unit_operator_config_id}`, {
			method: 'PUT',
			body: JSON.stringify(body),
			headers: {
				Authorization: state.app.user.token,
			},
			shouldSkipStatusError: true,
		})

		if (res.status !== 200) throw new Error(res.body.error)

		return res.body
	}
}

const deleteUnitOperatorConfig = (unit_operator_config_id) => {
	return async (dispatch, getState) => {
		const state = getState()
		const res = await callApi(`/unit_operator_config/${unit_operator_config_id}`, {
			method: 'DELETE',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		return res.body
	}
}

const getUnitOperatorConfigsByDate = (date) => {
	return async (dispatch, getState) => {
		const state = getState()
		const res = await callApi(`/unit_operator_config/date/${date}`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
			params: { date }
		})
		return res.body
	}
}

export default {
	...actions,
	addImage,
	batchUnitWialonReport,
	addUnitEmployee,
	assignTires,
	countUnitsByBrand,
	countUnitsByModel,
	createCustomReport,
	createTire,
	createUnitWithImage,
	copySupplyConfiguration,
	deleteImage,
	deleteUnit,
	driverGetUnitHourmeterHistory,
	driverGetUnitOdometerHistory,
	generateLocator,
	getCurrentOdometerUnits,
	getCustomUnits,
	getGeofenceZones,
	getFuelCatalog,
	getTypesCatalog,
	getUniqueUnitBrands,
	getUniqueUnitModels,
	getUnitIgniteSensor,
	getUnitHourmeterHistory,
	getUnitHourmeterHistoryByUsertype,
	getUnitOdometerHistory,
	getUnitOdometerHistoryByUserType,
	getUnitPhysiqueValuesBydate,
	getUnitWialonValuesBydate,
	getUnitWithSensors,
	getUnits,
	getUnitsForFuelDispatch,
	getUnitsForPerformanceReporting,
	getUnitsVisitedGeofences,
	getUnitsWithWialon,
	getUnitsWithXiga,
	getUserUnitPermits,
	getWialonCustomReportTemplate,
	getWialonUnitEntity,
	getWialonUnitEntityByUserType,
	getWialonUnits,
	importUnits,
	importUnitsWialon,
	loadAllUnits,
	loadClientUnits,
	loadNotImportedWialonUnits,
	loadUnits,
	loadUnitsUserCompany,
	loadWialonUnits,
	loadXigaVehicles,
	loadWialonUnitByID,
	regenerateLocator,
	setUnitTireOperation,
	updateTire,
	updateUnitEmployee,
	updateUnitWithImage,
	updateUnitsBrand,
	updateUnitsModel,
	upsertUserUnitPermits,
	getUnitOperatorConfigs,
	createUnitOperatorConfig,
	updateUnitOperatorConfig,
	deleteUnitOperatorConfig,
	getUnitOperatorConfigsByDate,
	renameUnitsFromWialon,
}
